import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isLogin: false,
    activeUserName: '',
    activeUserRole: localStorage.getItem('activeUserRole') || 'USER', // 'USER' or 'ADMIN'
    activeCompanyLogoURL: '',
    activeCompanyDetails: null, // { company_name, locality, street, place, city, state, post_code } from company details table
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLogin(state) {
            state.isLogin = true;
        },
        setLogout(state) {
            state.isLogin = false;
            state.activeUserName = '';
            state.activeUserRole = 'USER';
            state.activeCompanyLogoURL = '';
            state.activeCompanyDetails = null;
            localStorage.removeItem('activeUserRole');
        },
        setActiveUserName(state, action) {
            state.activeUserName = action.payload;
        },
        setActiveUserRole(state, action) {
            state.activeUserRole = action.payload || 'USER';
        },
        setActiveCompanyLogoURL(state, action) {
            state.activeCompanyLogoURL = action.payload;
        },
        clearCompanyLogo(state) {
            state.activeCompanyLogoURL = '';
            // Note: We intentionally don't clear activeUserName here
            // to ensure username persists even when logo is cleared
        },
        setActiveCompanyDetails(state, action) {
            state.activeCompanyDetails = action.payload;
        }
    }
});

export const authActions = authSlice.actions;
export default authSlice;
